
export enum sliceStateStatus {
    idle = 'idle',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected',
    sliceStateStatus = "sliceStateStatus"
}


export enum snackbarVariant {
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning'
}

export const snackbarErrorOptions = {
    preventDuplicate: true,
    variant: snackbarVariant.error,
    persist: false,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
    },
}

export enum spinnerAnimation { border = 'border',  grow = 'grow' }


export const systemStatus = {
    active: 'STATUS_ACTIVE',
    
    inactive: 'STATUS_INACTIVE',
    open: 'STATUS_OPEN',
    closed: 'STATUS_CLOSED',
    deleted: 'STATUS_DELETED',
    added: 'STATUS_ADDED',
    edited: 'STATUS_EDITED',

    suspended: 'STATUS_SUSPENDED',
    deceased: 'STATUS_DECEASED',
    renounce: 'STATUS_RENOUNCE',
    exempt: 'STATUS_EXEMPT',

    paid: 'STATUS_PAID',
    unpaid: 'STATUS_UNPAID',
    valid: 'STATUS_VALID',
    notvalid: 'STATUS_NOTVALID',

    matched: 'STATUS_MATCHED'
}

export enum appSections {
    users = 'SCN_USERS',
    settings = 'SCN_SETTINGS',
    
    // => APP CUSTOM
    accounts = 'SCN_ACCOUNTS',
    accreditation = 'SCN_ACCREDIT',
    votations = 'SCN_VOTES',
    events = "SCN_EVENTS",
    reports = "SCN_REPORTS",
    invitations = "SCN_INVITATIONS",
    substitutions = "SCN_SUBSTITUTIONS",
    partnership_lists = "SCN_LISTS",
    configuration = "SYS_CFG",
    rectidupli = "SCN_RECTIDUPLI"
}

export const sections = {
    
    settings: {
        root: 'SCN_SETTINGS'
        
        , users: 'SCN_USERS'
        
        , tools: {
            root: 'SYS_TOOLS'
            
            , export: 'SYS_EXPORT'
            , import:'SYS_IMPORT'
        }

        , partnership_lists: 'SCN_LISTS'
        , account_mngmt: 'SCN_ACCOUNT_MNGMT'
    },

    home: {
        accounts: 'SCN_ACCOUNTS',
        accreditation: 'SCN_ACCREDIT',
        votations: 'SCN_VOTES',
        events: "SCN_EVENTS",
        reports: "SCN_REPORTS",
        //invitations: "SCN_INVITATIONS",
        substitutions: "SCN_SUBSTITUTIONS",
        rectidupli: "SCN_RECTIDUPLI"
    },

    
}


export enum userRoles {
    administrator = 'ROLE_ADMIN',
    user = 'ROLE_USER',
    hero = 'SUPER_HERO'
}

export enum userAuthorizations {
    all = 'AUTH_ALL'
}

export enum accreditatedType {
    //accreditated_all = 'ACCR_ALL',

    accreditated_only = 'ACCR_ONLY',
    accreditated_not = 'ACCR_NOT'
}

export enum votersType {
    //voters_all = 'VOTES_ALL',

    voters_only = 'VOTES_ONLY',
    voters_not = 'VOTES_NOT'
}


export const actions = {
    add: 'ACN_ADD'
    , open: 'ACN_OPEN'
    , remove: "ACN_REMOVE"
    , edit: "ACN_EDIT"
    , save: "ACN_SAVE"
    , cancel: "ACN_CANCEL"
    , rectify: "ACN_RECTIFY"
    , import: "ACN_IMPORT"
    , export: "ACN_EXPORT"
    , none:  "ACN_NONE"
}



export const toastOptionsTopRight = {
    position: "top-right",  
    autoClose: 5000,        
    closeOnClick: true
}